<template>
  <div id="app">
    <transition
      enter-active-class="transition-opacity duration-700 ease-out"
      leave-active-class="transition-opacity duration-700 ease-in"
      enter-class="opacity-0 scale-70"
      enter-to-class="opacity-100 scale-100"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-70"
    >
      <LoadingScreen v-if="ui.loading" />
    </transition>
    <div v-if="!ui.loading">
      <Default />
    </div>
  </div>
</template>

<script>
import LoadingScreen from "~/pages/LoadingScreen";
import Default from "./layouts/Default";

export default {
  name: "App",

  components: {
    LoadingScreen,
    Default
  },

  data() {
    return {
      ui: {
        loading: true
      }
    };
  },

  mounted() {
    setTimeout(() => {
      this.ui.loading = false;
    }, 3000);
  }
};
</script>
